var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('enrollment-nav',{key:_vm.$route.fullPath,attrs:{"navdata":_vm.nav_array}}),_c('router-view',{attrs:{"navdata":_vm.nav_array},on:{"comEnvNavigation":_vm.comEnvNavigationFn,"comEnvNavigationBack":_vm.comEnvNavigationBackFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }